import { render, staticRenderFns } from "./BrandForm.vue?vue&type=template&id=6efac9e8&"
import script from "./BrandForm.vue?vue&type=script&lang=js&"
export * from "./BrandForm.vue?vue&type=script&lang=js&"
import style0 from "./BrandForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports